module.exports = __webpack_public_path__ + "static/media/foto2.def90645.JPG";